'use strict';
import $ from 'jquery';
import Cookies from 'js-cookie';

export default class OneTrust {
    static init() {
        new OneTrust();
    }

    constructor() {
        if (Cookies.get('OptanonAlertBoxClosed')) {
            this.addLeadForensics();
        }
        $(document).on('click', '#onetrust-accept-btn-handler', this.addLeadForensics.bind(this));
    }

    addLeadForensics() {
        //const leadforensics = document.createElement('script');

        //leadforensics.setAttribute('src', 'https://secure.leadforensics.com/js/sc/201311.js');

        //document.head.appendChild(leadforensics)
    }
}